<template>
  <div>

    <div class="card border-0 shadow-sm mt-3 mb-3" style="position: sticky">
      <div class="card-body">

        <form action="#" @submit.prevent="processSearch">
          <div class="input-group">
            <input type="text" name="search" v-model="search" class="form-control"
                   placeholder="Product ID, name or model number" aria-label="Product ID, name or model number"
                   aria-describedby="button-search-products" :disabled="processing_search">
            <div class="input-group-append">
              <button class="btn btn-outline-primary" type="submit" id="button-search-products" :disabled="processing_search">
                <i class="fas fa-circle-notch fa-spin" v-if="processing_search"></i>
                <i class="fas fa-search" v-if="!processing_search"></i>
                Products
              </button>
              <button class="btn btn-outline-primary" type="button" id="button-search-units" @click="promptProductUnitsSearch" :disabled="processing_units">
                <i class="fas fa-circle-notch fa-spin" v-if="processing_units"></i>
                <i class="fas fa-barcode" v-if="!processing_units"></i>
              </button>
            </div>
          </div>
        </form>

      </div>
    </div>

    <div class="text-center" v-if="processing_search">
      <i class="fas fa-sync-alt fa-spin"></i> Searching...
    </div>

    <div class="card border-0 shadow-sm" v-else-if="products===null">
      <div class="card-body">
        <div class="text-center p-4 text-muted">
          <i class="fas fa-boxes mr-2"></i> Search results will appear here
        </div>
      </div>
    </div>

    <div class="alert alert-warning shadow-sm" v-else-if="products.length===0">There are no products matching your search query</div>

    <div id="product-results" v-else>

      <div class="row px-2">

        <sale-search-product-result v-for="(product,k) in products" :key="k" :product="product" :processing_add_to_cart="processing_add_to_cart"></sale-search-product-result>

      </div>

    </div>

    <sale-search-product-units></sale-search-product-units>

  </div>
</template>

<script>
import axios from 'axios'
import jQuery from 'jquery'
import onScan from 'onscan.js'
import SaleSearchProductUnits from './SearchProductUnits'
import SaleSearchProductResult from './SearchProductResult'

export default {
  name: 'SaleSearchProducts',
  props: [
    'processing_add_to_cart'
  ],
  components: {
    SaleSearchProductUnits,
    SaleSearchProductResult
  },
  data () {
    return {
      processing_search: false,
      processing_units: false,

      beeps: {
        success: new Audio('/static/mp3/beep.mp3'),
        fail: new Audio('/static/mp3/beep-error.mp3')
      },

      search: null,
      products: null
    }
  },
  created () {
    if (!onScan.isAttachedTo(document)) {
      let vueInstance = this
      onScan.attachTo(document, {
        ignoreIfFocusOn: 'input, select',
        reactToPaste: true,
        onScan: function (code) {
          jQuery('input:focus, select:focus').each(function () {
            let val = jQuery(this).val()
            jQuery(this).val(val.replace(code.replace(/[/\\^$*+?.()|[\]{}]/g, '\\$&'), ''))
          })
          vueInstance.processUnitsSearch(code)
        },
        keyCodeMapper: function (oEvent) {
          if (oEvent.which === 189) {
            return '-'
          }

          // Fall back to the default decoder in all other cases.
          return onScan.decodeKeyEvent(oEvent)
        }
      })
    }
  },
  methods: {
    promptProductUnitsSearch () {
      jQuery('#modal-search-product-units').modal('show')
    },

    processSearch () {
      this.processing_search = true

      this.products = null

      axios.get('/products/search', {
        params: {
          // 'category': this.category_id,
          search: this.search,
          source: 'details.variants',
          page: 0,
          limit: 20
        }
      }).then((response) => {
        this.products = response.data.data
        this.$parent.setPaneHeights()
      }).catch(error => {
        this.$toast.error('Failed to retrieve products. ' + (typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : ''))
      }).finally(() => {
        this.processing_search = false
      })
    },

    async processUnitsSearch (barcode) {
      this.processing_units = true
      this.$parent._addToCart(0, 0, 0, 1, barcode)
        .then(() => {
          this.beeps.success.play()
        })
        .catch(error => {
          this.$toast.error(error)
          this.beeps.fail.play()
        })
        .finally(() => {
          this.processing_units = false
        })
    },

    addToCart (productId, variantId, variantMerchantId, quantity) {
      this.$parent.addToCart(productId, variantId, variantMerchantId, quantity)
    }
  }
}
</script>

<style>
  #product-results .product.not-purchasable {
    opacity: 0.5;
  }
</style>



// WEBPACK FOOTER //
// src/components/sale/partials/SearchProducts.vue